import { render, staticRenderFns } from "./CantReachServerSmall.vue?vue&type=template&id=d11c2620&"
import script from "./CantReachServerSmall.vue?vue&type=script&lang=js&"
export * from "./CantReachServerSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports